//var delay = 200;
//var loops = 50
////var pause = Math.floor(Math.random() * 15000);
//
////$(document).ready(function () {
////    
////    function cube() {
////        function flip(show, counter) {
////            var cube = 1;
////            // if max amount of repetitions is reached
////            if (counter > loops) return; // return exits the recursive function
////			$('.flip' + cube).css('transform', 'translateX(720deg)');
////            //$('.flip' + cube).toggleClass('show2', show);
////            //$('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
////            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
////            //   (not)show
////            //   counter increment
////            console.log('Show: ' + show)
////        }
////        flip(false, 0);
////    }
////    setTimeout(cube, delay*1);
////});
//$(document).ready(function () {
//    
//    function cube() {
//        function flip(show, counter) {
//            var cube = 2;
//            // if max amount of repetitions is reached
//            if (counter > loops) return; // return exits the recursive function
//
//            $('.flip' + cube).toggleClass('show2', show);
//            $('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
//            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
//            //   (not)show
//            //   counter increment
//            console.log('Show: ' + show)
//        }
//        flip(false, 0);
//    }
//    setTimeout(cube, delay*3);
//});
//
//$(document).ready(function () {
//    
//    function cube() {
//        function flip(show, counter) {
//            var cube = 3;
//            // if max amount of repetitions is reached
//            if (counter > loops) return; // return exits the recursive function
//
//            $('.flip' + cube).toggleClass('show2', show);
//            $('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
//            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
//            //   (not)show
//            //   counter increment
//            console.log('Show: ' + show)
//        }
//        flip(false, 0);
//    }
//    setTimeout(cube, delay*2);
//});
//
//$(document).ready(function () {
//    
//    function cube() {
//        function flip(show, counter) {
//            var cube = 4;
//            // if max amount of repetitions is reached
//            if (counter > loops) return; // return exits the recursive function
//
//            $('.flip' + cube).toggleClass('show2', show);
//            $('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
//            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
//            //   (not)show
//            //   counter increment
//            console.log('Show: ' + show)
//        }
//        flip(false, 0);
//    }
//    setTimeout(cube, delay*3.5);
//});
//
//$(document).ready(function () {
//    
//    function cube() {
//        function flip(show, counter) {
//            var cube = 5;
//            // if max amount of repetitions is reached
//            if (counter > loops) return; // return exits the recursive function
//
//            $('.flip' + cube).toggleClass('show2', show);
//            $('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
//            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
//            //   (not)show
//            //   counter increment
//            console.log('Show: ' + show)
//        }
//        flip(false, 0);
//    }
//    setTimeout(cube, delay*1.5);
//});
//
//$(document).ready(function () {
//    
//    function cube() {
//        function flip(show, counter) {
//            var cube = 6;
//            // if max amount of repetitions is reached
//            if (counter > loops) return; // return exits the recursive function
//
//            $('.flip' + cube).toggleClass('show2', show);
//            $('.flip' + cube + " " + '.front').toggleClass('flip-shadow', show); // Add boolean as parameter for toggle function
//            setTimeout(flip, 3000, !show, ++counter); // Call flip using parameters:
//            //   (not)show
//            //   counter increment
//            console.log('Show: ' + show)
//        }
//        flip(false, 0);
//    }
//    setTimeout(cube, delay*2.5);
//});


// WEBPACK FOOTER //
// ./scripts/libraries/clients.js